<template>
  <div>
    <div v-if="currentSubscription || newSubscription" class="container" data-test-hook="upgrade-to-multi-home-modal">
      <b-row v-if="currentSubscription?.renewalDate" class="mb-3 text-center" no-gutters>
        <h5 class="mx-auto header">{{ $t('xToReceivePremiumFeaturesYouMustUpgrade') }}</h5>
        <p class="upgrade-desc">
          {{
            $t('xWeWillApplyAProratedCredit', {
              0: getCurrencyString(selectedNewSubscription?.cost),
              1: $moment(currentSubscription.renewalDate).format($t('xShortDate'))
            })
          }}
        </p>
      </b-row>
      <b-row no-gutters>
        <b-col cols="0" style="width:100%">
          <SubscriptionUpgradeYearlyMonthlyCard
            :subscription-product="newSubscription"
            :apparatuses-to-upgrade="currentApparatuses"
            :apparatuses-to-add="newApparatuses"
            :is-new-plan="true"
            @setSelectedProduct="setSelectedProduct"
          />
        </b-col>
      </b-row>
      <b-row no-gutters class="mt-3">
        <b-col cols="12">
          <b-button
            variant="warning"
            class="w-100 btn btn-primary"
            @click="$emit('openPayment')"
            data-test-hook="upgrade-to-multi-home-modal-button-continue"
          >
            {{ $t('xUpgradeNow') }}
            <b-spinner class="ml-2" v-if="paying" />
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-center">
          <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SubscriptionUpgradeYearlyMonthlyCard from '../../../components/Enrollment/Subscription/Common/SubscriptionUpgradeYearlyMonthlyCard.vue'

export default {
  props: ['currentSubscription', 'newSubscription', 'apparatusList', 'newApparatuses'],
  emits: ['openPayment'],
  components: {
    SubscriptionUpgradeYearlyMonthlyCard
  },
  data() {
    return {
      currentApparatuses: [],
      selectedNewSubscription: null,
      paying: false
    }
  },
  methods: {
    setSelectedProduct(product) {
      this.selectedNewSubscription = product
      this.$emit('setSelectedProduct', product)
    }
  },
  mounted() {
    if (this.apparatusList && this.currentSubscription?.apparatuses) {
      this.currentApparatuses = this.currentSubscription.apparatuses.map(subApp => {
        return this.apparatusList.find(app => app.apparatusId === subApp.apparatusId)
      })
    }
  }
}
</script>
<style lang="scss">
.upgrade-desc {
  line-height: 1.4rem;
  margin-bottom: 0;
  font-size: 0.875rem;
}

.header {
  font-size: large;
  font-weight: 550;
  padding-left: 0;
}
</style>
